<template>
  <div>
    <!-- Left side column. contains the sidebar -->
    <app-sidebar></app-sidebar>

    <button data-toggle="offcanvas" role="button" class="sidebar-toggle btn-toggle-menu" @click="m__toggle_sidebar">
      <span class="ti-angle-double-left"></span>
    </button>

    <div class="content-wrapper dashboard-wrapper" id="dashboard-wrapper">
      <div v-if="m__is_expr() && !is_closed" style="padding: 15px 7px; background-color: #E0E8EF">
        <el-tag class="el-tag-expr" type="danger" @close="m__close_expire_tag()" closable>
          <i class="el-icon-info" style="font-weight: 700; font-size: 13px !important;"></i>
          &nbsp;&nbsp; {{ $t('base.expired_package', {x: m__get_expired_day()}) }}
          &nbsp;&nbsp;
          <router-link to="/product-pack"
                       style="color: orangered; text-decoration: underline !important; font-weight: 700; font-size: 13px">
            {{ $t('base.renew_now') }} !
          </router-link>
          &nbsp;&nbsp;
        </el-tag>
      </div>
      <div v-else-if="m__is_close_to_expr() && !is_closed" style="padding: 15px 7px; background-color: #E0E8EF">
        <el-tag class="el-tag-expr" type="warning" @close="m__close_expire_tag()" closable>
          <i class="el-icon-info" style="font-weight: 700; font-size: 13px !important;"></i>
          &nbsp;&nbsp; {{ $t('base.upcoming_expired_package', {x: m__get_expired_day()}) }}
          &nbsp;&nbsp;
          <router-link to="/product-pack" class="text-primary"
                       style="text-decoration: underline !important; font-weight: 700; font-size: 13px">
            {{ $t('base.renew_now') }} !
          </router-link>
          &nbsp;&nbsp;
        </el-tag>
      </div>

      <router-view></router-view>
    </div>

    <el-dialog :visible.sync="show_banner" :close-on-click-modal="true"
               width="auto" @close="m__close_banner()" :show-close="false">
      <div slot="title" style="padding:10px">
        <div style="font-size: 14px; line-height: 25px; text-align: center">
          <img style="object-fit: contain; width: auto; height: 500px; cursor: pointer; border-radius: 10px;"
               src="https://atosa.asia/download/mall_banner.jpg"
               alt=""
               @click="open_link('https://atosa.asia/huong-dan-cach-dang-ky-shopee-mall/'); m__close_banner() ">
          <div @click="m__close_banner()"
               style="width: 30px; height: 30px; position: absolute; background-color: #fff; border-radius: 50px; top: -5px; right: 0; text-align: center; font-size: 20px; cursor: pointer; display: flex; justify-content: center; align-items: center">
            <i class="el-icon-close" style="font-size: 20px; font-weight: bold"></i>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="no_shop_dialog" :close-on-click-modal="false"
               custom-class="no-body" width="630px">
      <div slot="title" style="padding:10px">
        <div style="text-align: center">
          <strong style="font-size: 18px">{{ $t('base.notice') }}</strong>
        </div>

        <div style="margin-top: 30px; font-size: 14px; line-height: 25px; text-align: center">
          {{ $t('shop.need_to_add_shop_message') }}.
        </div>

        <div style="margin-top: 40px; text-align: center">
          <el-button type="primary" size="small" @click="no_shop_dialog = false; $router.push('/shop')">
            {{ $t('shop.add_now') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Sidebar from './partials/Sidebar.vue'
import Header from '../../temp/partials/Header.vue'
import Footer from '../../temp/partials/Footer.vue'
import ControlSidebar from '../../temp/partials/ControlSidebar.vue'
import store from '../../store/index'
import * as Cookies from 'js-cookie'

export default {
  name: 'Dashboard',

  components: {
    'app-sidebar': Sidebar,
    'app-header': Header,
    'app-footer': Footer,
    'control-sidebar': ControlSidebar
  },

  data() {
    return {
      loading: false,
      version_info: {},
      feature_list: [],
      current_pack: [],
      day_number: 3,
      is_expr: false,
      is_close_to_expr: false,
      is_closed: false,
      show_banner: false,
      no_shop_dialog: false
    }
  },

  beforeRouteEnter(to, from, next) {
    if (to.query.lang && to.query.lang !== 'vi') {
      location.href = 'https://global.atosa.asia?lang=en'
    }

    try {
      let session = localStorage.getItem('session')
      if (typeof session !== 'undefined' && session !== null) {
        {
          store.dispatch('update_userInfo', JSON.parse(session) !== null ? JSON.parse(session) : {})
          next()
        }
      } else {
        next('/login')
      }
    } catch (e) {
      console.log(e)
      next('/login')
    }

  },

  async beforeMount() {
    if (!this.$store.state.userInfo || !this.$store.state.userInfo.token) {
      this.$router.push(`/login?r=${this.$route.path}`)
    } else {
      this.m_update_profile_info()
      this.EB.$on('update_profile', () => {
        this.m_update_profile_info()
      })
      this.EB.$on('show_no_shop_dialog', () => {
        this.no_shop_dialog = true
      })

      // this.show_banner = true
      // this.m__show_banner()
    }
  },

  methods: {
    m__show_banner() {
      try {
        const banner_log = localStorage.getItem('banner_log')
        if (!banner_log) {
          this.show_banner = true
        } else {
          const data = JSON.parse(banner_log)
          if (this.dayjs().isAfter(this.dayjs(data.show_on, 'YYYY/MM/DD'), 'day')) {
            this.show_banner = true
          }
        }
      } catch (e) {
        console.error(e)
        this.show_banner = false
      }
    },

    m__close_banner() {
      try {
        const data = {show_on: this.dayjs().format('YYYY/MM/DD')}
        localStorage.setItem('banner_log', JSON.stringify(data))
      } catch (e) {
        console.error(e)
      }

      this.show_banner = false
    },

    m__toggle_sidebar() {
      this.$nextTick(() => {
        const chat_widget = document.getElementsByClassName('widget-visible')
        if (chat_widget && chat_widget.length) {
          if (document.body.classList.contains('sidebar-collapse')) {
            chat_widget[0].style.setProperty('display', 'block', 'important')
          } else {
            chat_widget[0].style.setProperty('display', 'none', 'important')
          }
        }

        const fb_widget = document.getElementsByClassName('fb_dialog_content')
        if (fb_widget && fb_widget.length) {
          if (document.body.classList.contains('sidebar-collapse')) {
            fb_widget[0].style.setProperty('display', 'block', 'important')
          } else {
            fb_widget[0].style.setProperty('display', 'none', 'important')
          }
        }
      })
    },

    m__is_close_to_expr() {
      const extent_package = this.$store.state.package.extend_package ? this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing') : null
      if (extent_package && extent_package.package && !extent_package.package.default_for_free) {
        return this.dayjs(new Date(extent_package.license_to)).diff(this.dayjs(), 'd') <= this.day_number
      } else {
        return false
      }
    },

    m__is_expr() {
      const extent_package = this.$store.state.package.extend_package ? this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing') : null
      if (!extent_package) {
        return true
      }
      if (extent_package) {
        return !this.dayjs().isBefore(this.dayjs(new Date(extent_package.license_to)), 's')
      } else {
        return false
      }
    },

    m__get_expired_day() {
      const extent_package = this.$store.state.package.extend_package ? this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing') : null
      if (extent_package) {
        const date = this.dayjs(new Date(extent_package.license_to))
        return date.format('DD-MM-YYYY')
      } else {
        return ''
      }
    },

    m__close_expire_tag() {
      this.is_closed = true
    },

    m_update_profile_info() {
      this.$http.get(this.API.profile, this.cf())
        .then(resp => {
          this.$store.dispatch('update_userInfo', resp.body.data)
          Cookies.set('session', {})
        })
        .catch(error => {
          // console.error(error)
          Cookies.set('session', {})
          this.ntf_w(error)
          if (error && error.status && error.status === 401) {
            this.$store.state.userInfo = {}
            this.$store.state.license = []
            this.$router.push('/login')
          }
        })
    }
  }
}
</script>
<style lang="scss">
.btn-toggle-menu {
  z-index: 9999;
  position: fixed;
  left: 0;
  width: 25px;
  height: 60px;
  background-color: white;
  border: 0;
  border-radius: 0 10px 10px 0;
  top: calc(50vh - 30px);
  box-shadow: 3px 2px 5px rgba(45, 45, 48, .1);
  outline: 0;
  transition: all .3s ease-in-out;

  span {
    display: inline-block;
    transition: all .3s ease-in-out;
  }


  &:hover {
    background-color: whitesmoke;
    box-shadow: 4px 3px 6px rgba(45, 45, 48, .1);


  }
}

.sidebar-collapse {
  .btn-toggle-menu {
    * {
      display: inline-block;
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -o-transform: rotate(180deg);
      transform: rotate(180deg);
    }


  }
}

.header-version {
  z-index: 99999999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: orangered;
  color: white;
  padding: 5px;
  /*text-align:center;*/
  .btn-to-download {
    border: 0;
    background-color: white;
    color: black;
    border-radius: 3px;
    padding: 4px 10px;
    font-size: 11px;
    font-weight: 700;
    margin-left: 5px;
    -webkit-app-region: no-drag;

    &:hover {
      background-color: rgba(45, 45, 48, 1);
      color: white;
    }
  }
}

.content-wrapper {
  padding-top: 0 !important;
  height: 100vh;
  background-color: white;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: white;
  }

  &::-webkit-scrollbar-thumb {
    background-color: whitesmoke;

    &:hover {
      background-color: rgb(90, 90, 90);
    }
  }
}

.el-tag-expr {
  height: 40px !important;
  line-height: 38px !important;
  font-size: 13px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/Dashboard.vue